import Vue from 'vue';
import VueRouter from 'vue-router';
// 使用插件
Vue.use(VueRouter)
// 引用路由组件
import Index from '../views/Index'
import Solution from '../views/Solution'
import ProductCenter from '../views/ProductCenter'
import AboutUs from '../views/AboutUs'
// 配置路由
const router = new VueRouter({
	scrollBehavior(to, from, saveTop) {
		if (saveTop) {
			return saveTop;
		}
		else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	// mode: 'history',
	routes: [
		//重定向
		{
			path: '/',
			redirect: '/Index',
		}, {
			path: '/Index',
			component: Index,
			meta: {
				title: '脑结构(南京)科技有限公司'
			}
		}, {
			path: '/Solution',
			component: Solution,
			meta: {
				title: '解决方案-脑结构(南京)科技有限公司'
			}
		}, {
			path: '/ProductCenter',
			component: ProductCenter,
			meta: {
				title: '产品中心-脑结构(南京)科技有限公司'
			}
		}, {
			path: '/AboutUs',
			component: AboutUs,
			meta: {
				title: '关于我们-脑结构(南京)科技有限公司'
			}
		},
	]
})
router.beforeEach((to, from, next) => {
	//beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) {
		//判断是否有标题
		console.log(to.meta.title)
		document.title = to.meta.title
	}
	else {
		document.title = '默认title'
	}
	next()
})

export default router
